import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://yqxkeegpghkwinvtygnj.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlxeGtlZWdwZ2hrd2ludnR5Z25qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY1NTc3MDIsImV4cCI6MjEwMjEzMzcwMn0.Tr722nIyGVUYcD17A7F2jFXLI5S9cua4XcyEK1fSn6I';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
});
